export default __webpack_public_path__ + "static/media/tab03_title02.bf2a0a80.png";